import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import './registerServiceWorker'
import router from './router'
import firebase from "firebase";
Vue.config.productionTip = false
import * as VueGoogleMaps from "vue2-google-maps";
import { VueMaskDirective } from "v-mask";
// import VueSocialSharing from 'vue-social-sharing'




firebase.initializeApp({
  apiKey: "AIzaSyAmz7GdG7msN67qIvIMkFIeX9x8mAdKwQc",
  authDomain: "jcmattogrossoproj-eb1e7.firebaseapp.com",
  projectId: "jcmattogrossoproj-eb1e7",
  storageBucket: "jcmattogrossoproj-eb1e7.appspot.com",
  messagingSenderId: "657365773854",
  appId: "1:657365773854:web:4b641091cb7ce46072480f",
  measurementId: "G-1X46KT1H84"
});

export const db = firebase.firestore()
export const storage = firebase.storage()


//PUSH NOTIFICATION  
// esse bloco basicamente é esse código e o aquivo firabase-messaging-sw.js na pasta public 
// acessar https://console.firebase.google.com/project/JoaoCesarMattogrosso/notification  para mandar msg
 
//.isSupported()  pq o Safari nao suporta o messaging e dava tela branca
// if  (firebase.messaging.isSupported()) {
//         const messaging = firebase.messaging();
//         messaging.requestPermission()
//         .then(function(){
//           console.log('tem permissão');
//           return messaging.getToken();
//         })
//         .then(function(token){
//           console.log(token);
//         })
//         .catch(function(err){
//           console.log('Ocorreu um errin '+err);
//         })


//       messaging.onMessage(function(payload){
//         console.log('onMessage :'+payload)
//       });
      
//       messaging.usePublicVapidKey("BCc3--ckD7ETzDVLb0Pfckw13iGAnewcGAdOhOpMsuLzfi65yvIoq3jNvhIjQhXs3uGNBs0oty1MQiaDtWkarc0");
// }
//PUSH NOTIFICATION




//MAPS http://cristiantorresalfaro.blogspot.com/2020/08/mostrar-ubicacion-en-google-map-vue-js.html
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyC9Kxpu_eidRBQqolX1ZI_g2Y6ytlSbwC8",
    libraries: "places" // necessary for places input

  },
});

Vue.directive("mask", VueMaskDirective);

// Vue.use(VueSocialSharing);




// OFFLINE
// db.settings({
//   cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
// });

// db.enablePersistence()

//db.disableNetwork(); // desativa internet 

// OFFLINE

    

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
